import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import DatePicker from "react-datepicker";
import { v4 as uuidv4 } from 'uuid';
import "rc-time-picker/assets/index.css";
import Authenticate from "../Functions/MedRepAuthenticate"

function timeStringToFloat(time) {
    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
}

export default class AddClient extends React.Component {

    constructor() {
        super();
        this.state = {
            createCount: 0, showRequiredAlert: false, alertString: "", disableSave: false, name: "", specialties: [], availability: "", specialty: "", type: "",
            CPC: "", CF: "", potential: [], brick: "", area: "", subarea: "", address: "", phone: "", mobile: "", email: "", birthday: "", items: "", deal: "",
            days: [], hours: "", areas: [], allSubareas: [], products: [], requiredFields: { Name: false, Type: false, Mobile: false, CF: false, Area: false },
            user: "", reps: [], userId: 0, USClients: [], USClientItems: [], UUID: [], USClients2: [], USClientItems2: [], UUID2: [], supervisorInput: false,
            Reps: [], subareas: [], token: "", daysSave: [], time: "", preventSymbols: ["e", "E", "+", "-", "."], authenticate: false, alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const user = localStorage.getItem("User");
        const count = localStorage.getItem("UnsyncedClientsCount");
        const token = localStorage.getItem("Token");
        const isSupervisor = localStorage.getItem("isSupervisor");
        await this.setState({ user: JSON.parse(user), createCount: JSON.parse(count), token: JSON.parse(token), supervisorInput: JSON.parse(isSupervisor) });
        const readURL = constantURI() + "odooController/MedRepRead";

        if (!this.state.isSupervisor) {
            const RepsBody = {
                "jsonrpc": "2.0",
                "params": {
                    "method": "search_read",
                    "model": "res.users",
                    "args": [],
                    "kwargs": {
                        "fields": ["name", "supervisor"],
                        "domain": [["supervisor", "=", this.state.user]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(readURL, RepsBody).then((response) => {
                    return response.json().then((data) => {
                        if (data.result !== undefined) {
                            this.setState({ Reps: data.result });
                            localStorage.setItem('Reps', JSON.stringify(this.state.Reps));
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                const Reps = localStorage.getItem('Reps');
                this.setState({ Reps: JSON.parse(Reps) });
            }
        }

        const repsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["x_salesrepresentative", "=", true]]
                }
            },
            "token": this.state.token
        }
        const specialtiesBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "x_specialties",
                "args": [],
                "kwargs": {
                    "fields": ["x_name"]
                }
            },
            "token": this.state.token
        }
        const potentialBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "edm.potential",
                "args": [],
                "kwargs": {
                    "fields": ["name"]
                }
            },
            "token": this.state.token
        }
        const areaBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.country.state",
                "args": [],
                "kwargs": {
                    "fields": ["name"]
                }
            },
            "token": this.state.token
        }
        const subareaBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "x_res.city",
                "args": [],
                "kwargs": {
                    "fields": ["x_name", "x_country_state_id"],
                }
            },
            "token": this.state.token
        }
        const productsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "product.product",
                args: [],
                kwargs: {
                    fields: ["default_code", "name"]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, repsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ reps: data.result })
                        localStorage.setItem('Reps', JSON.stringify(this.state.reps));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, specialtiesBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ specialties: data.result })
                        localStorage.setItem('Specialties', JSON.stringify(this.state.specialties));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, potentialBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ potential: data.result })
                        localStorage.setItem('Potential', JSON.stringify(this.state.potential));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, areaBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ areas: data.result })
                        localStorage.setItem('Area', JSON.stringify(this.state.areas));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, subareaBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ allSubareas: data.result })
                        localStorage.setItem('Potential', JSON.stringify(this.state.allSubareas));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, productsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ products: data.result, loading: false })
                        localStorage.setItem('ProductsList', JSON.stringify(this.state.products));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const reps = localStorage.getItem('Reps');
            const prods = localStorage.getItem('ProductsList');
            const subareas = localStorage.getItem('Potential');
            const areas = localStorage.getItem('Area');
            const potential = localStorage.getItem('Potential');
            const specialties = localStorage.getItem('Specialties');
            this.setState({
                reps: JSON.parse(reps), products: JSON.parse(prods), loading: false, allSubareas: JSON.parse(subareas), areas: JSON.parse(areas),
                potential: JSON.parse(potential), specialties: JSON.parse(specialties)
            });
        }
        if (this.state.user !== "Med Rep 10") {
            this.state.reps.map((item) => {
                if (item.name === this.state.user)
                    this.setState({ userId: item.id });
            })
        }
    }

    validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    onChangeSelectedRep = async (e) => {
        this.state.reps.map((item) => {
            if (item.name === e.target.value)
                this.setState({ userId: item.id });
        })
    }

    onChangeName = (e) => {
        this.setState({ name: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Name = false })
        else
            this.setState({ ...this.state.requiredFields.Name = true })
    }

    onChangeAvailability = (e) => {
        this.setState({ availability: e.target.value })
    }

    onChangeSpecialty = (e) => {
        this.setState({ specialty: e.target.value })
    }

    onChangeType = (e) => {
        this.setState({ type: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Type = false })
        else
            this.setState({ ...this.state.requiredFields.Type = true })
    }

    onChangeCPC = (e) => {
        this.setState({ CPC: e.target.value })
    }

    onChangeCF = (e) => {
        this.setState({ CF: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.CF = false })
        else
            this.setState({ ...this.state.requiredFields.CF = true })
    }

    onChangeBrick = (e) => {
        this.setState({ brick: e.target.value })
    }

    onChangeArea = async (e) => {
        await this.setState({ area: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Area = false })
        else
            this.setState({ ...this.state.requiredFields.Area = true })

        const tempSubarea = [];
        await this.state.allSubareas.forEach((item) => {
            if (item.x_country_state_id[0] === Number(this.state.area)) {
                tempSubarea.push(item);
            }
        })
        await this.setState({ subareas: tempSubarea });
    }

    onChangeSubarea = (e) => {
        this.setState({ subarea: e.target.value })
    }

    onChangeAddress = (e) => {
        this.setState({ address: e.target.value })
    }

    onChangePhone = (e) => {
        this.setState({ phone: e.target.value })
    }

    onChangeMobile = (e) => {
        this.setState({ mobile: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Mobile = false })
        else
            this.setState({ ...this.state.requiredFields.Mobile = true })
    }

    onChangeEmail = (e) => {
        this.setState({ email: e.target.value });

    }

    onChangeBirthday = (date) => {
        this.setState({ birthday: date });
    }

    onChangeItems = (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(itemsSelected[i].value);
            }
        }
        this.setState({ items: values });
    }

    onChangeDeal = (e) => {
        this.setState({ deal: e.target.value })
    }

    onChangeDays = (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(Number(itemsSelected[i].value));
            }
        }
        this.setState({ days: values });
    }

    onChangeHours = (e) => {
        this.setState({ hours: e.target.value })
    }

    onSync = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableSync: true });
        const createClientURL = constantURI() + "OdooController/CreateClient";

        const clients = localStorage.getItem('UnsyncedClients');
        const clientItems = localStorage.getItem('UnsyncedClientItems');
        const uuid = localStorage.getItem('UUIDClients');
        await this.setState({ USClients2: JSON.parse(clients), USClientItems2: JSON.parse(clientItems), UUID2: JSON.parse(uuid) });

        this.state.USClients2.map(async (client, clientIndex, clientArr) => {
            if (this.state.authenticate) {
                await _post(createClientURL, client).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            if (this.state.USClientItems2 !== null) {
                                await this.state.USClientItems2.map(async (item, index) => {
                                    if (item.params.args[0].x_partner_id === this.state.UUID2[index]) {
                                        await this.setState({ ...this.state.USClientItems2[clientIndex].params.args[0].x_partner_id = data.result })
                                        await _post(createClientURL, this.state.USClientItems2[index])
                                    }
                                })
                            }
                            if (clientIndex === clientArr.length - 1) {
                                await localStorage.setItem('UnsyncedClientsCount', JSON.stringify(0));
                                await localStorage.setItem('UnsyncedClients', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedClientItems', JSON.stringify([]));
                                await localStorage.setItem('UUIDClients', JSON.stringify([]));
                                await alert("Synced Successfully");
                                this.props.history.push("./HCPs");
                            }
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                alert("Only sync when connected to the Internet!");
                await this.setState({ disableSync: false });
            }
        })

    }

    onSave = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        var toFill = false;
        var alertString = "";
        Object.keys(this.state.requiredFields).map(async (item) => {
            if (!this.state.requiredFields[item]) {
                toFill = true;
                alertString += item + ", ";
                await this.setState({ alertString: alertString });
            }
        })
        const isEmail = this.validateEmail(this.state.email);
        if (toFill === true) {
            this.setState({ showRequiredAlert: true });
        }
        else if (!isEmail) {
            alert("Enter a valid email");
        }
        else if (!toFill && isEmail) {
            await this.setState({ showRequiredAlert: false, disableSave: true, });

            var clients = (this.state.USClients === null || this.state.USClients.length === 0) ? [] : this.state.USClients;
            var clientItems = (this.state.USClientItems === null || this.state.USClientItems.length === 0) ? [] : this.state.USClientItems;
            var uuid = (this.state.UUID === null || this.state.UUID.length === 0) ? [] : this.state.UUID;

            const createClientURL = constantURI() + "OdooController/CreateClient";
            const createClientBody = {
                "jsonrpc": "2.0",
                "params": {
                    "method": "create",
                    "model": "res.partner",
                    "args": [
                        {
                            "name": this.state.name,
                            "clienttype": Number(this.state.type),
                            "x_specialty_id": this.state.specialty,
                            "x_availability": this.state.availability,
                            "potential": this.state.CPC,
                            "cf": this.state.CF,
                            "brick": this.state.brick,
                            "state_id": this.state.area,
                            "x_city_id": this.state.subarea,
                            "street": this.state.address,
                            "phone": this.state.phone,
                            "mobile": this.state.mobile,
                            "email": this.state.email,
                            "birthday": this.state.birthday === "" ? false : this.state.birthday,
                            "x_deal": this.state.deal,
                            "x_wdays": this.state.days,
                            "x_workhours": this.state.hours,
                            "x_repuser": this.state.userId,
                            "customer_rank": 1,
                            "prefered_visit_time": timeStringToFloat(new Date(this.state.time).toLocaleString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: false
                            }))
                        }
                    ],
                    "kwargs": {}
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(createClientURL, createClientBody).then(async (response) => {
                    return response.json().then((data) => {
                        if (data.result !== undefined) {
                            if (this.state.items.length === 0) {
                                this.props.history.push("/HCPs");
                            }
                            else {
                                this.state.items.map(async (item, index, arr) => {
                                    const itemsBody = {
                                        "jsonrpc": "2.0",
                                        "params": {
                                            "method": "create",
                                            "model": "x_clientitems",
                                            "args": [
                                                {
                                                    "x_partner_id": data.result,
                                                    "x_product_id": item
                                                }
                                            ],
                                            "kwargs": {}
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createClientURL, itemsBody).then((response) => {
                                        return response.json().then((data) => {
                                            if (data.result !== undefined) {
                                                if (index === arr.length - 1)
                                                    this.props.history.push("/HCPs");
                                            }
                                            else {
                                                this.setState({ alertUndefined: true });
                                            }
                                        })
                                    })
                                })
                            }
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                await clients.push(createClientBody);
                this.setState({ createCount: this.state.createCount + 1 });
                await localStorage.setItem('UnsyncedClientsCount', JSON.stringify(this.state.createCount));
                await localStorage.setItem('UnsyncedClients', JSON.stringify(clients));

                var test = uuidv4();
                await uuid.push(test);
                localStorage.setItem('UUIDClients', JSON.stringify(uuid));

                if (this.state.items.length === 0) {
                    await alert("This Client is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                    this.props.history.push("./HCPs");
                }
                else {
                    this.state.items.map(async (item, index, arr) => {
                        const itemsBody = {
                            "jsonrpc": "2.0",
                            "params": {
                                "method": "create",
                                "model": "x_clientitems",
                                "args": [
                                    {
                                        "x_partner_id": test,
                                        "x_product_id": item
                                    }
                                ],
                                "kwargs": {}
                            },
                            "token": this.state.token
                        }
                        clientItems.push(itemsBody);
                        if (index === arr.length - 1) {
                            await localStorage.setItem('UnsyncedClientItems', JSON.stringify(clientItems));
                            await alert("This Client is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                            this.props.history.push("./HCPs");
                        }
                    })
                }
            }
        }
    }

    onChangeTime = (value) => {
        this.setState({ time: value });
    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                { (this.state.createCount === 0 || this.state.createCount === null) ?
                    <div className="alert alert-secondary">You have 0 changes to sync with Odoo.</div> :
                    <div className="col alert alert-danger">You have {this.state.createCount} changes to sync with Odoo.
                          <div className="row">
                            <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                            <div className="col-sm-4 d-flex flex-row-reverse">
                                <div className="btn" style={stylesMed.wideButton} onClick={this.onSync}>Sync Changes</div>
                            </div>
                        </div>
                    </div>
                }
                {(!this.state.showRequiredAlert) ?
                    null :
                    <div className="col alert alert-danger">{this.state.alertString} are required fields that should be filled.</div>
                }
                {(!this.state.alertUndefined) ?
                    null :
                    <div className="col alert alert-danger">
                        <div className="row">
                            <h6 className="col-sm-8">There seems to be a problem.</h6>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                    Reload</div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.goBack()} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="col"><h5 style={stylesMed.visitTitle}>Create HCP</h5></div>
                    <div className="col d-flex flex-row-reverse">
                        <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save HCP</div>
                    </div>
                </div>
                <div className="mt-4 p-3 mb-4" style={stylesMed.cardBackgroundColor}>
                    <div className="row">
                        <div className="col">
                            <label>Name*:</label>
                            <input className="col form-control" value={this.state.name} onChange={this.onChangeName}
                                style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Type*:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.type} onChange={this.onChangeType}
                                name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                <option value=""></option>
                                <option value={1}>Doctor</option>
                                <option value={2}>Pharmacy</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Phone:</label>
                            <input className="col form-control" value={this.state.phone} onChange={this.onChangePhone} type="number"
                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Mobile:</label>
                            <input className="col form-control" value={this.state.mobile} onChange={this.onChangeMobile} type="number"
                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Area:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.area} onChange={this.onChangeArea}
                                name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.areas.map((item) => {
                                    return (
                                        <option value={item.id}>{item.name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        <div className="col">
                            <label>Zone:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.subarea} onChange={this.onChangeSubarea}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.subareas.map((item) => {
                                    return (
                                        <option value={item.id}>{item.x_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Email:</label>
                            <input className="col form-control" value={this.state.email} onChange={this.onChangeEmail}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Birthday:</label>
                            <DatePicker style={stylesMed.reportClientInput} className="form-control" selected={this.state.birthday} onChange={(date) => this.onChangeBirthday(date)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Address:</label>
                            <textarea className="col form-control" value={this.state.address} onChange={this.onChangeAddress}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group invisible">
                            <label>Birthday:</label>
                            <DatePicker className="form-control" selected={this.state.birthday} onChange={(date) => this.onChangeBirthday(date)} />
                        </div>
                    </div>
                </div>
                <div className="mt-4 p-3" style={stylesMed.cardBackgroundColor}>
                    <div className="row">
                        <div className="col form-group">
                            <label>Specialty:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.specialty} onChange={this.onChangeSpecialty}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.specialties.map((item) => {
                                    return (
                                        <option value={item.id}>{item.x_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        <div className="col form-group">
                            <label>CPC:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.CPC} onChange={this.onChangeCPC}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.potential.map((item) => {
                                    return (
                                        <option value={item.id}>{item.name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        {/*<div className="col form-group">*/}
                        {/*    <label>Preferred Visit Time:</label><br></br>*/}
                        {/*    <TimePicker className="col" value={this.state.time} onChange={this.onChangeTime}*/}
                        {/*        showSecond={false} allowEmpty />*/}
                        {/*</div>*/}
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>CF:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.CF} onChange={this.onChangeCF}
                                name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                <option value=""></option>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                            </select>
                        </div>
                        <div className="col form-group">
                            <label>Availability:</label>
                            <textarea className="col form-control" value={this.state.availability} onChange={this.onChangeAvailability}
                                style={stylesMed.reportClientInput} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Brick:</label>
                            <textarea className="col form-control" value={this.state.brick} onChange={this.onChangeBrick}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col">
                            <label>Items of Interest:</label>
                            <select multiple className="col-sm-6 form-control" id="sel1" value={this.state.items} onChange={this.onChangeItems}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                {this.state.products.map((item) => {
                                    return (
                                        <option value={item.id}>{item.name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Working Days:</label>
                            <select multiple className="col-sm-6 form-control" id="sel1" value={this.state.days} onChange={this.onChangeDays}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value={1}>Monday</option>
                                <option value={2}>Tuesday</option>
                                <option value={3}>Wednesday</option>
                                <option value={4}>Thursday</option>
                                <option value={5}>Friday</option>
                                <option value={6}>Saturday</option>
                                <option value={7}>Sunday</option>
                            </select>
                        </div>
                        <div className="col form-group">
                            <label>Working Hours:</label>
                            <textarea className="col form-control" value={this.state.hours} onChange={this.onChangeHours}
                                style={stylesMed.reportClientInput} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Scientific Support:</label>
                            <textarea className="col form-control" value={this.state.deal} onChange={this.onChangeDeal}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className={(!this.state.supervisorInput) ? "col form-group" : "col form-group invisible"}>
                            <label>Select Representative:</label>
                            <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}
                                onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>
                                <option value=""></option>
                                {this.state.Reps.map((item, index) => {
                                    return (
                                        <option key={index} value={item.name}>{item.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    {/*<div className="row">*/}
                    {/*    <div className={(!this.state.supervisorInput) ? "col form-group" : "col form-group invisible"}>*/}
                    {/*        <label>Select Representative:</label>*/}
                    {/*        <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}*/}
                    {/*            onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>*/}
                    {/*            <option value=""></option>*/}
                    {/*            {this.state.Reps.map((item, index) => {*/}
                    {/*                return (*/}
                    {/*                    <option key={index} value={item.name}>{item.name}</option>*/}
                    {/*                )*/}
                    {/*            })}*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*    <div className="col form-group invisible">*/}
                    {/*        <label>Preferred Visit Time:</label><br></br>*/}
                    {/*        <TimePicker className="col" value={this.state.time} onChange={this.onChangeTime}*/}
                    {/*            showSecond={false} allowEmpty />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}